export const DnDItemTypes = {
    ATTRIBUTE: 'attribute'
};
